import { render, staticRenderFns } from "./verkoop.vue?vue&type=template&id=77973646&scoped=true"
import script from "./verkoop.vue?vue&type=script&lang=js"
export * from "./verkoop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77973646",
  null
  
)

export default component.exports